import FlightPathAnimation from '../../../components/feature/FlightPathAnimation';

const columns = [
  {
    title: 'Product',
    links: [
      { label: 'Features', href: '#features' },
      { label: 'Pricing', href: '#pricing' },
      { label: 'Integrations', href: '#features' },
      { label: 'Changelog', href: '#' },
    ],
  },
  {
    title: 'Company',
    links: [
      { label: 'About', href: '#' },
      { label: 'Blog', href: '#blog' },
      { label: 'Contact', href: '#' },
      { label: 'Careers', href: '#' },
    ],
  },
  {
    title: 'Legal',
    links: [
      { label: 'Privacy Policy', href: '#' },
      { label: 'Terms of Service', href: '#' },
      { label: 'Cookie Policy', href: '#' },
    ],
  },
];

const travelIcons = [
  { icon: 'ri-plane-line', top: '8%', left: '2%', rotate: '-25deg', size: 'text-5xl', opacity: 'opacity-[0.05]' },
  { icon: 'ri-ship-line', top: '15%', left: '18%', rotate: '0deg', size: 'text-4xl', opacity: 'opacity-[0.05]' },
  { icon: 'ri-train-line', top: '55%', left: '8%', rotate: '-5deg', size: 'text-3xl', opacity: 'opacity-[0.04]' },
  { icon: 'ri-hotel-line', top: '10%', left: '45%', rotate: '5deg', size: 'text-4xl', opacity: 'opacity-[0.05]' },
  { icon: 'ri-flight-takeoff-line', top: '70%', left: '38%', rotate: '10deg', size: 'text-3xl', opacity: 'opacity-[0.04]' },
  { icon: 'ri-landscape-line', top: '20%', left: '72%', rotate: '-8deg', size: 'text-4xl', opacity: 'opacity-[0.05]' },
  { icon: 'ri-plane-fill', top: '60%', left: '80%', rotate: '20deg', size: 'text-3xl', opacity: 'opacity-[0.04]' },
  { icon: 'ri-building-2-line', top: '10%', left: '88%', rotate: '0deg', size: 'text-4xl', opacity: 'opacity-[0.05]' },
  { icon: 'ri-compass-3-line', top: '80%', left: '60%', rotate: '15deg', size: 'text-3xl', opacity: 'opacity-[0.04]' },
  { icon: 'ri-sun-line', top: '85%', left: '92%', rotate: '0deg', size: 'text-3xl', opacity: 'opacity-[0.04]' },
  { icon: 'ri-map-pin-line', top: '40%', left: '55%', rotate: '-10deg', size: 'text-2xl', opacity: 'opacity-[0.04]' },
  { icon: 'ri-anchor-line', top: '50%', left: '27%', rotate: '0deg', size: 'text-3xl', opacity: 'opacity-[0.04]' },
];

export default function Footer() {
  return (
    <footer className="relative bg-gradient-to-br from-gray-900 via-gray-900 to-gray-800 border-t border-gray-700 px-6 pt-16 pb-8 overflow-hidden">
      <FlightPathAnimation variant="footer" />
      {/* Travel icons decorative background */}
      {travelIcons.map((item, i) => (
        <span
          key={i}
          className={`absolute pointer-events-none select-none text-teal-400 ${item.size} ${item.opacity}`}
          style={{ top: item.top, left: item.left, transform: `rotate(${item.rotate})` }}
        >
          <i className={item.icon} />
        </span>
      ))}

      <div className="relative z-10 max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row gap-12 pb-12 border-b border-gray-700">
          {/* Brand */}
          <div className="w-full lg:w-72 shrink-0 flex flex-col gap-4">
            <div className="flex items-center gap-2">
              <div className="w-7 h-7 bg-gradient-to-br from-teal-500 to-emerald-500 rounded-md flex items-center justify-center">
                <i className="ri-plane-line text-white text-sm" />
              </div>
              <span className="text-base font-semibold text-white tracking-tight">
                Tre<span className="bg-gradient-to-r from-teal-400 to-emerald-400 bg-clip-text text-transparent">Waz</span>
              </span>
            </div>
            <p className="text-sm text-gray-400 leading-relaxed max-w-xs">
              The AI Operating System for travel agencies. Automate enquiries, WhatsApp, CRM, and bookings in one platform.
            </p>
            <div className="flex items-center gap-3 mt-1">
              {['ri-twitter-x-line', 'ri-linkedin-line', 'ri-instagram-line'].map((icon) => (
                <a
                  key={icon}
                  href="#"
                  rel="nofollow"
                  className="w-8 h-8 flex items-center justify-center rounded-md border border-gray-600 hover:border-teal-500 hover:text-teal-400 transition-colors cursor-pointer"
                >
                  <i className={`${icon} text-gray-400 text-sm`} />
                </a>
              ))}
            </div>
          </div>

          {/* Nav columns */}
          <div className="flex-1 grid grid-cols-2 sm:grid-cols-3 gap-8">
            {columns.map((col) => (
              <div key={col.title}>
                <p className="text-xs font-semibold text-gray-300 uppercase tracking-wider mb-4">{col.title}</p>
                <ul className="flex flex-col gap-3">
                  {col.links.map((link) => (
                    <li key={link.label}>
                      <a
                        href={link.href}
                        rel="nofollow"
                        className="text-sm text-gray-500 hover:text-teal-400 transition-colors cursor-pointer"
                      >
                        {link.label}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        {/* Bottom */}
        <div className="flex flex-col sm:flex-row items-center justify-between gap-3 pt-8">
          <p className="text-xs text-gray-500">&copy; {new Date().getFullYear()} TreWaz. All rights reserved.</p>
          <p className="text-xs text-gray-500 flex items-center gap-1.5">
            <i className="ri-plane-line text-teal-500 text-sm" />
            AI Operating System for Travel Agencies
          </p>
        </div>
      </div>
    </footer>
  );
}
